import React from 'react';
import UtilsFunctions from "../../../../utils/UtilsFunctions";
import {toast} from "react-toastify";

const BuyFactorJozTable = ({sendData, setSendData}) => {

  const svgDelete = <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <g fill="#FFADB5" clipPath="url(#clip0_3720_2653)">
      <path
        d="M6.114 10.387a.494.494 0 01-.354-.147.503.503 0 010-.707L9.534 5.76a.503.503 0 01.706 0 .503.503 0 010 .707L6.467 10.24a.484.484 0 01-.353.147z"></path>
      <path
        d="M9.887 10.387a.494.494 0 01-.353-.147L5.76 6.467a.503.503 0 010-.707.503.503 0 01.707 0l3.773 3.773a.503.503 0 010 .707c-.1.1-.226.147-.353.147z"></path>
      <path
        d="M10 15.167H6C2.38 15.167.835 13.62.835 10V6C.834 2.38 2.381.833 6.001.833h4c3.62 0 5.166 1.547 5.166 5.167v4c0 3.62-1.546 5.167-5.166 5.167zM6 1.833C2.928 1.833 1.835 2.927 1.835 6v4c0 3.073 1.093 4.167 4.167 4.167h4c3.073 0 4.166-1.094 4.166-4.167V6c0-3.073-1.093-4.167-4.166-4.167H6z"></path>
    </g>
    <defs>
      <clipPath id="clip0_3720_2653">
        <path fill="#fff" d="M0 0H16V16H0z"></path>
      </clipPath>
    </defs>
  </svg>

  const inputChangeHandler = (data, e, key) => {
    let temp = [...sendData.tableData]
    let value = ""

    if (e.value !== "") {
      value = UtilsFunctions.removeCommas(e.value)
    } else {
      if (key === 1) {
        value = "1"
      } else {
        value = "0"
      }
    }

    if (!isNaN(parseFloat(+value)) && !value.includes(".")) {
      temp.forEach((v) => {
        if (v.unicId === data.unicId) {
          if (key === 1) {
            v.number = value
          } else if (key === 2) {
            v.price = value
          } else if (key === 3) {
            if (+value < +v.price) {
              v.discount = value
            } else {
              toast.error("تخفیف باید از قیمت کم تر باشد")
            }
          }
        }
      })
      setSendData({...sendData, tableData: temp})
    }
  }

  const onDeleteRowHandler = (data) => {
    let temp = [...sendData.tableData]
    const filtered = temp.filter((item) => {
      return item.unicId !== data.unicId
    })
    setSendData({...sendData, tableData: filtered})
  }


  try {
    return (
      <ul className="factor-joz-table">
        <li className="header-table">
          <span style={{width: '5%', borderRadius: '0px 5px 0px 0px'}}>عملیات</span>
          <span style={{width: '10%'}}>نام انبار</span>
          <span style={{width: '10%'}}>کد محصول</span>
          <span style={{width: '25%'}}>نام محصول</span>
          <span style={{width: '10%'}}>ویژگی</span>
          <span style={{width: '10%'}}>تعداد</span>
          <span style={{width: '10%'}}>قیمت</span>
          <span style={{width: '10%'}}>تخفیف</span>
          <span style={{width: '10%', borderRadius: '5px 0px 0px 0px'}}>جمع کل</span>
        </li>

        {sendData.tableData.length > 0 ?
          sendData.tableData.map((v, index) =>
            <li className="body-table" key={"row" + index}>
              <span style={{width: '5%'}}>
                <div onClick={() => onDeleteRowHandler(v)}>
                  {svgDelete}
                </div>
              </span>
              <span style={{width: '10%'}}>{v.storeName}</span>
              <span style={{width: '10%'}}>{v.productId}</span>
              <span style={{width: '25%'}}>{v.name}</span>
              <span style={{width: '10%'}}>{v.color + " " + v.size}</span>
              <span style={{width: '10%'}}>
                <input value={v.number}
                       onChange={(e) => inputChangeHandler(v, e.target, 1)}/>
              </span>
              <span style={{width: '10%'}}>
                <input type={"text"} value={UtilsFunctions.addCommas(v.price)}
                       onChange={(e) => inputChangeHandler(v, e.target, 2)}/>
              </span>
              <span style={{width: '10%'}}>
                <input value={UtilsFunctions.addCommas(v.discount)}
                       onChange={(e) => inputChangeHandler(v, e.target, 3)}/>
              </span>
              <span style={{width: '10%'}}>{UtilsFunctions.addCommas((+v.price - +v.discount) * +v.number)}</span>
            </li>
          ) :
          <p className={"no-row-data"}>کالایی انتخاب نشده</p>}

        <li className="footer-table"></li>
      </ul>
    );
  } catch (e) {
    return <>{e.toString()}</>
  }
};

export default React.memo(BuyFactorJozTable);